/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import {
	Box,
	Button,
	ComposableTypography,
	InputField,
	Spacer,
	Typography,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { CoreHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { BannerCard } from '@components';
import { rem } from '@helpers';
import { Diamond } from '@icons';
import { useCardPromotionalCodeHelper } from './cardPromotionalCode.helper';
import { PromoCodeStatus } from '@api/izibizi-xp';

export const CardPromotionalCode: React.FC = () => {
	const {
		resources,
		onChange,
		onClickClear,
		onClickValidate,
		promotionalCodeStatus,
		promotionalCode,
		inputCodeStatus,
		handleOnClickBack,
	} = useCardPromotionalCodeHelper();
	const defaultWidth = '100%';
	const defaultJustifyContent = 'space-evenly';
	const iconDiamond = <Diamond />;

	return (
		<Box>
			<BannerCard
				imageSource={iconDiamond}
				containerStyle={{
					padding: rem(16, 24),
					width: '100%',
					alignItems: 'center',
				}}
			>
				<Box
					styles={{
						alignItems: 'center',
						justifyContent: defaultJustifyContent,
						width: defaultWidth,
						marginLeft: rem(24),
					}}
				>
					{inputCodeStatus === 'valid' ? (
						(promotionalCodeStatus === PromoCodeStatus.ACTIVE && (
							<>
								<Box
									styles={{
										alignItems: 'flex-start',
										width: defaultWidth,
										flexDirection: 'column',
									}}
								>
									<Box>
										<Typography appearance="body-100-04">{resources.titleSuccess}</Typography>
									</Box>
									<Spacer vertical={rem(8)} />
									<Box>
										<ComposableTypography
											text={resources.subtitleSuccess}
											baseProps={{
												appearance: 'body-75-02',
											}}
											tags={{
												monthsTag: { appearance: 'body-75-04' },
											}}
										/>
									</Box>
								</Box>
							</>
						)) ||
						(promotionalCodeStatus === PromoCodeStatus.NONE && (
							<>
								<Box
									styles={{
										alignItems: 'flex-start',
										width: defaultWidth,
										flexDirection: 'column',
									}}
								>
									<Box>
										<Typography appearance="body-100-04">{resources.titleNoCampaign}</Typography>
									</Box>
									<Spacer vertical={rem(8)} />
									<Box>
										<ComposableTypography
											text={resources.subtitleNoCampaign}
											baseProps={{
												appearance: 'body-75-02',
											}}
											tags={{
												monthsTag: { appearance: 'body-75-04' },
											}}
										/>
									</Box>
									<div style={{ flexShrink: 0 }}>
										<Spacer vertical={rem(24)} horizontal={rem(24)} />
									</div>
									<Box styles={{ width: 'auto' }}>
										<Button size="small" appearance="primary" onPress={handleOnClickBack}>
											{'Voltar'}
										</Button>
									</Box>
								</Box>
							</>
						)) ||
						((promotionalCodeStatus === PromoCodeStatus.INACTIVE ||
							promotionalCodeStatus === PromoCodeStatus.EXPIRED) && (
							<>
								<Box
									styles={{
										alignItems: 'flex-start',
										width: defaultWidth,
										flexDirection: 'column',
									}}
								>
									<Box>
										<Typography appearance="body-100-04">{resources.titleOffCampaign}</Typography>
									</Box>
									<Spacer vertical={rem(8)} />
									<Box>
										<ComposableTypography
											text={resources.subtitleOffCampaign}
											baseProps={{
												appearance: 'body-75-02',
											}}
											tags={{
												monthsTag: { appearance: 'body-75-04' },
											}}
										/>
									</Box>
									<div style={{ flexShrink: 0 }}>
										<Spacer vertical={rem(24)} horizontal={rem(24)} />
									</div>
									<Box styles={{ width: 'auto' }}>
										<Button size="small" appearance="primary" onPress={handleOnClickBack}>
											{'Voltar'}
										</Button>
									</Box>
								</Box>
							</>
						)) ||
						(promotionalCodeStatus === PromoCodeStatus.USED && (
							<>
								<Box
									styles={{
										alignItems: 'flex-start',
										width: defaultWidth,
										flexDirection: 'column',
									}}
								>
									<Box>
										<Typography appearance="body-100-04">{resources.titleNoCampaign}</Typography>
									</Box>
									<Spacer vertical={rem(8)} />
									<Box>
										<ComposableTypography
											text={resources.subtitleNoCampaign}
											baseProps={{
												appearance: 'body-75-02',
											}}
											tags={{
												monthsTag: { appearance: 'body-75-04' },
											}}
										/>
									</Box>
									<div style={{ flexShrink: 0 }}>
										<Spacer vertical={rem(24)} horizontal={rem(24)} />
									</div>
									<Box styles={{ width: 'auto' }}>
										<Button size="small" appearance="primary" onPress={handleOnClickBack}>
											{'Voltar'}
										</Button>
									</Box>
								</Box>
							</>
						))
					) : (
						<>
							<Box
								styles={{
									justifyContent: defaultJustifyContent,
									alignItems: 'center',
									width: defaultWidth,
								}}
							>
								<Box styles={{ width: 'auto', whiteSpace: 'nowrap' }}>
									<Typography appearance="body-100-04">{resources.title}</Typography>
								</Box>
								<div style={{ flexShrink: 0 }}>
									<Spacer horizontal={rem(24)} />
								</div>
								<div style={{ width: defaultWidth, marginTop: '15px' }}>
									<Spacer vertical={rem(8)} />
									<InputField
										maxCharacters={20}
										mode="default"
										label={resources.placeholderInput}
										value={promotionalCode}
										debounce={550}
										status={inputCodeStatus === 'invalid' ? 'error' : 'default'}
										onChangeValue={onChange}
										onClearButtonPress={onClickClear}
										bottomMessage={
											inputCodeStatus === 'invalid'
												? {
														text: {
															content: resources.messageInput,
															props: {
																appearance: 'microcopy-100-04',
																colorsLevel: 'feedbackError',
															},
														},
												  }
												: {
														text: {
															props: {
																appearance: 'microcopy-100-04',
																colorsLevel: 'feedbackError',
															},
														},
												  }
										}
									/>
								</div>
								<div style={{ flexShrink: 0 }}>
									<Spacer horizontal={rem(24)} />
								</div>
								<Box styles={{ width: 'auto' }}>
									<Button
										size="medium"
										disabled={
											inputCodeStatus === 'invalid' || CoreHelper.isNullOrEmpty(promotionalCode)
										}
										appearance="primary"
										onPress={onClickValidate}
									>
										{resources.buttonValidate}
									</Button>
								</Box>
							</Box>
						</>
					)}
				</Box>
			</BannerCard>
		</Box>
	);
};
